export default [
  // HOMEPAGE SECTIONS
  {
    name: 'Work',
    link: '/work/',
  },
  {
    name: 'Services',
    link: '/#services',
    isAnchor: true,
    children: [
      {
        link: '/full-cycle-product-development/',
        name: 'Full Cycle Product Development',
      },
      {
        link: '/product-design-and-development/',
        name: 'Product Design and Development',
      },
      {
        link: '/development-teams/',
        name: 'Development Teams',
      },
      {
        link: '/machine-learning/',
        name: 'Machine Learning',
      },
      {
        link: '/digital-transformation/',
        name: 'Digital Transformation',
      },
    ],
  },
  {
    name: 'Approach',
    link: '/#approach',
    isAnchor: true,
  },
  {
    name: 'Culture',
    link: '/#culture',
    isAnchor: true,
  },
  {
    name: 'About',
    link: '/#about',
    isAnchor: true,
  },
  {
    name: 'Contact',
    link: '/contact/',
  },
  {
    name: 'Blog',
    link: '/blog/',
  },
  {
    name: 'Career',
    link: '/career/',
  },
  {
    name: 'Privacy Policy',
    link: '/privacy-policy/',
    onlyFooter: true,
  },
];
